export enum WorkflowStageTaskStatusEnum {
  NeedsCompleted = 1,
  Completed = 3,
  CancelledByWorkflow = 5
}

export const WorkflowStageTaskStatusOptions = [
{ id: 1, label: 'Needs Completed' },
{ id: 3, label: 'Completed' },
{ id: 5, label: 'Cancelled By Workflow' }
];
